module.exports = {"short":"zh_cn","long":"Chinese (Simplified)","createdBy":"g-plane"}


//////////////////
// WEBPACK FOOTER
// ./store/zh_cn/meta.json
// module id = EQ+A
// module chunks = 1